import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Offcanvas } from 'react-bootstrap';

const ProjectModal = ({ showModal, handleClose, clients, projectId, projectData, addProject, defaultClientId, editProject, fetchClients }) => {

    const [formData, setFormData] = useState({
        name: '',
        code: '',
        client_id: '',
        lead_id: '',
        contact_id: '',
        PM_id: '',
        vendor_id: '',
        type: '',
        start_date: '',
        expected_value: '',
        max_expenditure: '',
        expenditure_amount: '',
        documents: '',
        payment_term: '',
        custom_term_days: '',
        subscription_start_date: '',
        subscription_due_date: '',
        is_subscription_active: true,
        vendor_subscription_end_dates: '',
    });

    useEffect(() => {
        if (showModal && clients.length === 0) {
            fetchClients();
        }
    }, [showModal, clients.length]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (showModal) {
            if (projectId && projectData) {
                setFormData({
                    ...projectData,
                    client_id: projectData.client_id || defaultClientId || '',
                    payment_term: projectData.payment_term || 'yearly',
                    subscription_start_date: projectData.subscription_start_date || '',
                    custom_term_days: projectData.custom_term_days || '',
                    subscription_due_date: projectData.subscription_due_date || '',
                    is_subscription_active: projectData.is_subscription_active ?? true,
                    vendor_subscription_end_dates: projectData.vendor_subscription_end_dates || '',
                });
            } else {
                setFormData({
                    name: '',
                    code: '',
                    client_id: defaultClientId || '',
                    lead_id: '',
                    contact_id: '',
                    PM_id: '',
                    vendor_id: '',
                    type: '',
                    start_date: '',
                    expected_value: '',
                    max_expenditure: '',
                    expenditure_amount: '',
                    documents: '',
                });
            }
        }
    }, [showModal, projectId, projectData, defaultClientId]);

    useEffect(() => {
        const { expected_value, max_expenditure } = formData;
        if (expected_value && max_expenditure) {
            const percentage = (max_expenditure / 100) * expected_value;
            setFormData((prev) => ({
                ...prev,
                expenditure_amount: percentage,
            }));
        }
    }, [formData.expected_value, formData.max_expenditure]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
        if (errors[name]) {
            setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData((prevData) => ({
                ...prevData,
                documents: file,
            }));
        }
    };

    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Name is required';
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return;
        }
        let apierrors;
        if (projectId) {
            apierrors = await editProject(projectId, formData);
        } else {
            apierrors = await addProject(formData);
        }

        if (apierrors && Object.keys(apierrors).length > 0) {
            setErrors(apierrors);
        } else {
            setErrors({});
            handleClose();
        }
    };

    return (
        <>
            {/* Custom Backdrop - Only show when ProjectModal is open */}
            {showModal && (
    <div
        className="custom-backdrop"
        style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.25)', // light dim (Bootstrap style)
            zIndex: 1059, // between parent & child offcanvas
        }}
        onClick={handleClose}
    />
)}



            <Offcanvas 
                show={showModal} 
                onHide={handleClose} 
                placement='end' 
                style={{ 
                    width: '660px',
                    zIndex: 1060 // Higher than backdrop and Client offcanvas
                }}
                className="ProjectModal-offcanvas"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{projectId ? 'Edit Project' : 'Create Project'}</Offcanvas.Title>
                </Offcanvas.Header>
                <hr style={{ margin: 0 }} /><br />

                <Offcanvas.Body>
                    <Form>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group controlId="name" className="mb-3">
                                    <Form.Label style={{ fontSize: "13px" }}>Name</Form.Label>
                                    <Form.Control
                                        style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        className={`form-control ${errors?.name ? 'is-invalid' : ''}`}
                                        required
                                    />
                                    {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.name}</div>}
                                </Form.Group>
                            </Col>
                             <Col md={6}>
                                <Form.Group controlId="client_id" className="mb-3">
                                    <Form.Label style={{ fontSize: "13px" }}>Client</Form.Label>
                                    <Form.Select
                                        style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                        name="client_id"
                                        value={formData.client_id}
                                        onChange={handleChange}
                                    >
                                        <option value="" disabled>Select a Client</option>
                                        {clients
                                            .filter((client) => client.contact_type === 'client')
                                            .map((client) => (
                                                <option key={client.id} value={client.id}>
                                                    {client.name}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                           

                            <Col md={6}>
                                <Form.Group controlId="type" className="mb-3">
                                    <Form.Label style={{ fontSize: "13px" }}>Project Type</Form.Label>
                                    <Form.Select
                                        style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                        name="type"
                                        value={formData.type}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select</option>
                                        <option value="1">Project(In-House)</option>
                                        <option value="2">Project(Out-Source)</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                             <Col md={6}>
                                <Form.Group controlId="start_date" className="mb-3">
                                    <Form.Label style={{ fontSize: "13px" }}>Project Expected StartDate</Form.Label>
                                    <Form.Control
                                        style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                        type="date"
                                        name="start_date"
                                        value={formData.start_date}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                           
                            <Col md={6}>
                                <Form.Group controlId="expected_value" className="mb-3">
                                    <Form.Label style={{ fontSize: "13px" }}>Expected Value</Form.Label>
                                    <Form.Control
                                        style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                        type="number"
                                        name="expected_value"
                                        value={formData.expected_value}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                              <Col md={6}>
                                <Form.Group controlId="max_expenditure" className="mb-3">
                                    <Form.Label style={{ fontSize: "13px" }}>Maximum Expenditure(IN %)</Form.Label>
                                    <Form.Control
                                        style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                        type="number"
                                        name="max_expenditure"
                                        value={formData.max_expenditure}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                          
                            <Col md={6}>
                                <Form.Group controlId="expenditure_amount" className="mb-3">
                                    <Form.Label style={{ fontSize: "13px" }}>Maximum Expenditure Amount</Form.Label>
                                    <Form.Control
                                        style={{ fontSize: '13px', maxWidth: '280px', borderRadius: '14px', height: '35px', border: '0.5px solid rgb(232, 233, 237)' }}
                                        type="number"
                                        name="expenditure_amount"
                                        value={formData.expenditure_amount}
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>
                                <Col md={6}>
                                <Form.Group controlId="payment_term" className="mb-3">
                                    <Form.Label style={{ fontSize: "13px" }}>Payment Term</Form.Label>
                                    <Form.Select
                                        name="payment_term"
                                        value={formData.payment_term}
                                        onChange={handleChange}
                                        style={{
                                            fontSize: '13px',
                                            maxWidth: '280px',
                                            borderRadius: '14px',
                                            height: '35px',
                                            border: '0.5px solid rgb(232, 233, 237)'
                                        }}
                                    >
                                        <option value="">Select</option>
                                        <option value="yearly">Yearly</option>
                                        <option value="halfyearly">Half Yearly</option>
                                        <option value="quarterly">Quarterly</option>
                                        <option value="custom">Custom</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                        

                            <Col md={6}>
                                <Form.Group controlId="subscription_start_date" className="mb-3">
                                    <Form.Label style={{ fontSize: "13px" }}> Start Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="subscription_start_date"
                                        value={formData.subscription_start_date}
                                        onChange={handleChange}
                                        style={{
                                            fontSize: '13px',
                                            maxWidth: '280px',
                                            borderRadius: '14px',
                                            height: '35px',
                                            border: '0.5px solid rgb(232, 233, 237)'
                                        }}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group controlId="vendor_subscription_end_dates" className="mb-3">
                                    <Form.Label style={{ fontSize: "13px" }}> End Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="vendor_subscription_end_dates"
                                        value={formData.vendor_subscription_end_dates}
                                        onChange={handleChange}
                                        style={{
                                            fontSize: '13px',
                                            maxWidth: '280px',
                                            borderRadius: '14px',
                                            height: '35px',
                                            border: '0.5px solid rgb(232, 233, 237)'
                                        }}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group controlId="subscription_due_date" className="mb-3">
                                    <Form.Label style={{ fontSize: "13px" }}> Due Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="subscription_due_date"
                                        value={formData.subscription_due_date}
                                        onChange={handleChange}
                                        style={{
                                            fontSize: '13px',
                                            maxWidth: '280px',
                                            borderRadius: '14px',
                                            height: '35px',
                                            border: '0.5px solid rgb(232, 233, 237)'
                                        }}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group controlId="documents" className="mb-3">
                                    <Form.Label style={{ fontSize: "13px" }}>Project Document</Form.Label>
                                    <Form.Control
                                        style={{
                                            fontSize: '13px',
                                            maxWidth: '280px',
                                            borderRadius: '14px',
                                            height: '35px',
                                            border: '0.5px solid rgb(232, 233, 237)'
                                        }}
                                        type="file"
                                        name="documents"
                                        onChange={handleFileChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Offcanvas.Body>
                <div className="p-3 d-flex justify-content-end border-top">
                    <Button variant="secondary" type="submit" onClick={handleSubmit}>
                        {projectId ? 'Update' : 'Create'}
                    </Button>
                </div>
            </Offcanvas>
        </>
    );
};

export default ProjectModal;

